import { Navigate, useLocation } from 'react-router-dom';

/** Keeps query string (e.g. ?cycle=) when redirecting legacy demand-planning paths. */
export function DemandPlanningSubrouteRedirect({ to }: { to: string }) {
  const location = useLocation();
  return <Navigate to={`${to}${location.search}`} replace />;
}
